import classNames from 'classnames'
import { DeepPartial } from 'utility-types'
import { TUSL2Interest } from '../../types/page-api-response'
import { USL2WidgetHeading } from './heading'
import Text from '@/stories/components/Common/NewText'
import { getLastUpdatedDate } from '@/revamp/pods/common/utils/get-last-update'

type TCardsListing = {
  widgetData: DeepPartial<TUSL2Interest>
}

const Cards = ({ data }) => {
  if (!data) return null

  const { stTime, endTime, detail, toc, perc } = data
  return (
    <div className="flex flex-col gap-2 rounded-xl border p-4">
      {detail && <Text appearance="body2">{detail}</Text>}
      {stTime && endTime && (
        <Text appearance="body1" addClassName="text-brand-grey-dark">
          <span className="text-brand-black font-medium"> Time period: </span>
          <time dateTime={stTime}>{getLastUpdatedDate(stTime)}</time> to{' '}
          <time dateTime={endTime}>{getLastUpdatedDate(endTime)}</time>
        </Text>
      )}
      {perc && (
        <Text
          appearance="body1"
          addClassName={classNames({
            'text-brand-green-dark': toc === 'green',
            'text-brand-red-cinnabar': toc === 'red',
          })}
        >
          <span className="text-brand-black mr-2 font-medium">Change:</span>
          <Text appearance="subtitle2" tag="span">
            {perc}&nbsp;
          </Text>
          versus previous 30 day period
        </Text>
      )}
    </div>
  )
}

const CardsListingV1 = (props: TCardsListing) => {
  const { widgetData } = props
  const { d } = widgetData
  if (!d?.list?.length) return null
  return (
    <div>
      <USL2WidgetHeading tooltip={d.too} subheading={d.she}>
        {d.he}
      </USL2WidgetHeading>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-20">
        {d.list.map((item, index) => {
          return <Cards key={index} data={item} />
        })}
      </div>
    </div>
  )
}
export default CardsListingV1
